module.exports = __webpack_public_path__ + "img/number.ec75ad5d.svg";